import {defaultChatConfig, IChatConfig} from './chat-config';

export interface FarmacreditsConfigInterface {
  eyl: boolean,
  active: boolean,
  providers: boolean
}

export const defaultFarmacreditsConfig: FarmacreditsConfigInterface = {
  eyl: false,
  active: false,
  providers: false,
};

export interface FirebaseFlags {
  activeCovid?: boolean;
  vipModalEnabled?: boolean;
  farmacreditsConfig?: FarmacreditsConfigInterface;
  configShowEta?: ConfigShowEta;
  authActiveConfig?: AuthActiveConfig;
  qualtricsActive?: boolean;
  searchMarketplace?: boolean;
  verify_medical_formula_config?: VerifyMedicalFormulaConfig;
  showRxProducts?: boolean;
  chatConfig?: IChatConfig;
  cuidamosTuSalud?: boolean;
}

export interface ConfigShowEta {
  show_in_cart?: boolean;
  show_in_checkout?: boolean;
  show_in_tracking_progress?: boolean;
  show_in_tracking_finished?: boolean;
}

export const defaultConfigShowEta: ConfigShowEta = {
  show_in_cart: false,
  show_in_checkout: false,
  show_in_tracking_progress: false,
  show_in_tracking_finished: false,
};

export interface AuthActiveConfig {
  apple?: boolean;
  facebook?: boolean;
  google?: boolean;
}

export const defaultAuthActiveConfig: AuthActiveConfig = {
  apple: false,
  facebook: false,
  google: false,
};

export interface VerifyMedicalFormulaConfig {
  verify: boolean;
  require_presciption_medical_text?: string;
}

export const defaultVerifyMedicalFormulaConfig: VerifyMedicalFormulaConfig = {
  verify: false,
  require_presciption_medical_text: 'Para pedir este producto necesitas la fórmula médica',
};

export const defaultRemoteConfig: FirebaseFlags = {
  activeCovid: false,
  vipModalEnabled: false,
  qualtricsActive: false,
  searchMarketplace: true,
  farmacreditsConfig: defaultFarmacreditsConfig,
  configShowEta: defaultConfigShowEta,
  authActiveConfig: defaultAuthActiveConfig,
  verify_medical_formula_config: defaultVerifyMedicalFormulaConfig,
  showRxProducts: false,
  chatConfig: defaultChatConfig,
};

export interface FirebaseAuthResponse {
  user: {
    uid: string,
    email: string,
    apiKey: string,
    appName: string,
    photoURL: string,
    tenantId: string,
    createdAt: string,
    authDomain: string,
    phoneNumber: string,
    displayName: string,
    lastLoginAt: string,
    isAnonymous: boolean,
    redirectEventId: null,
    emailVerified: boolean,
    multiFactor: {
      enrolledFactors: []
    }
    providerData: Array<{
      uid: string,
      email: string,
      photoURL: string,
      providerId: string,
      displayName: string,
      phoneNumber: string,
    }>,
    stsTokenManager: {
      apiKey: string,
      accessToken: string,
      refreshToken: string,
      expirationTime: number,
    }
  },
  credential: {
    idToken: string,
    providerId: string,
    accessToken: string,
    signInMethod: string,
    oauthIdToken: string,
  },
  additionalUserInfo: {
    isNewUser: boolean,
    providerId: string,
    profile: {
      id: string,
      hd: string,
      name: string,
      email: string,
      picture: string,
      given_name: string,
      family_name: string,
      granted_scopes: string,
      verified_email: boolean,
    }
  },
  operationType: string
}
